var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[
    _vm.buttonType,
    { bordered: _vm.withBorder },
    { fixedWidth: _vm.description === null }
  ],on:{"click":function($event){return _vm.$emit('onClick')}}},[(_vm.description)?_c('span',[_vm._v(_vm._s(_vm.description))]):_vm._e(),_c('img',{attrs:{"src":_vm.src}})])}
var staticRenderFns = []

export { render, staticRenderFns }